<template>
  <div class="Home">
    <!-- <v-app-bar flat dense class="grey lighten-2"> <img :src="require('@/assets/images/freedLogo.svg')" width="74px"/> </v-app-bar> -->
    <AppBar />
    <component
      :is="findClientDetailsFFomMetaData.componentName"
      :ref="findClientDetailsFFomMetaData.myRefName"
      :value="selectModel(getCustomerDetailsChppInput, undefined)"
      @input="
        (newValue) =>
          updateModel(getCustomerDetailsChppInput, newValue, undefined)
      "
      v-bind="findClientDetailsFFomMetaData.props"
    ></component>


    <v-fade-transition>
      <component
        v-if="customerDetails?.clientFileId"
        :ref="ChppCreditorInfoFDataTableMetaData.myRefName"
        :is="ChppCreditorInfoFDataTableMetaData.componentName"
        :value="customerDetails.freshworksCHPPCreditorInfoList"
        v-bind="ChppCreditorInfoFDataTableMetaData.props"
      >
        <template v-slot:top-action-right>
          <v-btn
            small
            outlined
            color="primary"
            class="ml-5"
            @click="handleViewDetails"
            >View Details</v-btn
          >
        </template>
      </component>
    </v-fade-transition>

    <component
      :is="addCreditorNotesFFomMetaData.componentName"
      :ref="addCreditorNotesFFomMetaData.myRefName"
      :value="selectModel(addCreditorNotesInput, undefined)"
      @input="
        (newValue) => updateModel(addCreditorNotesInput, newValue, undefined)
      "
      v-bind="addCreditorNotesFFomMetaData.props"
    ></component>

    <component
      :is="clientFileDetailsFFormMetaData.componentName"
      :ref="clientFileDetailsFFormMetaData.myRefName"
      :value="selectModel(customerDetails, undefined)"
      v-bind="clientFileDetailsFFormMetaData.props"
    ></component>

    <component
      :is="notesDrawerMetaData.componentName"
      :ref="notesDrawerMetaData.myRefName"
      v-bind="notesDrawerMetaData.props"
    ></component>


    <!-- collect-payment drawer  -->
    <component
      v-if="showCollectPaymentDrawer"
      :is="collectPaymentPGDrawerFFormMetaData.componentName"
      :ref="collectPaymentPGDrawerFFormMetaData.myRefName"
      :value="selectModel(collectThroughPgInput, undefined)"
      @input="
        (newValue) => updateModel(collectThroughPgInput, newValue, undefined)
      "
      v-bind="collectPaymentPGDrawerFFormMetaData.props"
    ></component>

    <!-- payment request list display table  -->
    <component
      :is="paymentRequestListFDataTableMetaData.componentName"
      :ref="paymentRequestListFDataTableMetaData.myRefName"
      :value="paymentRequestOutputList"
      v-bind="paymentRequestListFDataTableMetaData.props"
    ></component>

  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
import * as ServerData from "@/../src-gen/server-data";
import * as Action from "@/../src-gen/action";
import FindClientDetailsFFomMDP from "./FindClientDetailsFFomMDP";
import ModelVue from "@/components/ModelVue";
import FForm from "@/components/form/FForm.vue";
import ChppCreditorInfoFDataTableMDP from "./ChppCreditorInfoFDataTableMDP";
import FDataTable from "@/components/table/FDataTable.vue";
import FFormDrawer from "@/components/form/FFormDrawer.vue";
import AddCreditorNotesFFomMDP from "./AddCreditorNotesFFomMDP";
import FSnackbar from "@/fsnackbar";
import AppBar from "@/components/bar/chppAppBar.vue";
import ClientFileDetailsFFormMDP from "./ClientFileDetailsFFormMDP";
import CollectPaymentPGDrawerFFormMDP from "./CollectPaymentPGDrawerFFormMDP";
import PaymentRequestListFDataTableMDP from "./PaymentRequestListFDataTableMDP";
import NotesDrawerMDP from "./NotesDrawerMDP";
import FDrawer from "@/components/FDrawer.vue";
@Component({
  components: {
    FForm,
    FDataTable,
    FFormDrawer,
    AppBar,
    FDrawer,
  },
})
export default class Home extends ModelVue {
  getCustomerDetailsChppInput: Data.Spine.GetCustomerDetailsChppInput =
    new Data.Spine.GetCustomerDetailsChppInput();

  customerDetails: Data.Spine.GetCustomerDetailsChppOutput =
    new Data.Spine.GetCustomerDetailsChppOutput();
  
  collectThroughPgInput: Data.Payment.CollectThroughPgInput = new Data.Payment.CollectThroughPgInput();

  paymentRequestOutputList: Data.Payment.PaymentRequestDetailsWithEntries[] = [];


  @Store.Getter.Login.LoginDetails.userName
  userName: string;

  addCreditorNotesInput: Data.Spine.AddCreditorNotesInput =
    new Data.Spine.AddCreditorNotesInput();

  showAddCreditorNotesForm: boolean = false;
  showClientFileNotes: boolean = false;
  showClientFileDetails: boolean = false;
  showCollectPaymentDrawer: boolean = false;

  get findClientDetailsFFomMetaData() {
    return new FindClientDetailsFFomMDP({
      parent: this,
      onClick: () => {
        this.getCustomerDetailsChpp();
      },
    }).getMetaData();
  }

  get cfID() {
    // to avoid warning named as cfID
    return this.customerDetails?.clientFileId;
  }

  get spaAmount() {
    // return this.paymentRequestOutputList[0]?.amount || 0;
    return this.customerDetails.spaAmount || 0;
  }

  get notesDrawerMetaData() {
    return new NotesDrawerMDP({
      isVisible: this.showClientFileNotes,
      onClose: () => {
        this.showClientFileNotes = false;
      },
      customerDetails: this.customerDetails,
      notesAdded: () => this.getCustomerDetailsChpp(),
    }).getMetaData();
  }

  get ChppCreditorInfoFDataTableMetaData() {
    return new ChppCreditorInfoFDataTableMDP({ parent: this }).getMetaData();
  }

  get paymentRequestListFDataTableMetaData() {
    return new PaymentRequestListFDataTableMDP({parent: this}).getMetaData();
  }

  get clientFileDetailsFFormMetaData() {
    return new ClientFileDetailsFFormMDP({
      parent: this,
      isVisible: this.showClientFileDetails,
      onClose: () => {
        this.showClientFileDetails = false;
      },
    }).getMetaData();
  }

  get addCreditorNotesFFomMetaData() {
    return new AddCreditorNotesFFomMDP({
      parent: this,
      isVisible: this.showAddCreditorNotesForm,
      onClose: () => {
        this.showAddCreditorNotesForm = false;
        this.addCreditorNotesInput = new Data.Spine.AddCreditorNotesInput();
      },
      onClick: () => {
        this.addCreditorNote();
      },
    }).getMetaData();
  }

  get collectPaymentPGDrawerFFormMetaData() {
    return new CollectPaymentPGDrawerFFormMDP({
      parent: this,
      isVisible: this.showCollectPaymentDrawer,
      onClose: () => {
        this.showCollectPaymentDrawer = false;
      },
    }).getMetaData();
  }

  handleAddClientFileDetailsClick() {
    this.showClientFileDetails = true;
  }

  handleViewDetails() {
    const routeData = this.$router.resolve({
      name: "CHPPRoot.MetabaseDashboard",
      params: { dashboardId: "50" },
      query: {
        clientfilenumber: this.customerDetails?.clientFileNumber,
      },
    });

    window.open(routeData.href, "_blank");
  }

  getCustomerDetailsChpp() {
    Action.Spine.GetCustomerDetailsChpp.execute(
      this.getCustomerDetailsChppInput,
      (output) => {
        this.customerDetails = output;

        setTimeout(() => {
          this.getSPAPaymentRequestsList();
        }, 300)
      }
    );
  }

  handleCreditorSelect(creditor: Data.Spine.FreshworksChppCreditorInfo) {
    this.addCreditorNotesInput.creditorId = creditor.creditorId;
    this.addCreditorNotesInput.clientFileNumber =
      this.customerDetails.clientFileNumber;
    this.showAddCreditorNotesForm = true;
  }

  clearDataTable() {
    (
      this.$refs[this.ChppCreditorInfoFDataTableMetaData.myRefName] as any
    ).clearSelectedItems();
  }

  addCreditorNote() {
    FSnackbar.confirm({
      message: "Are you sure want to add the note",
      onConfirm: () => {
        Action.Spine.AddCreditorNotes.execute(
          this.addCreditorNotesInput,
          (output) => {
            FSnackbar.success("Succesfully added the note");
            this.showAddCreditorNotesForm = false;
            this.clearDataTable();
          }
        );
      },
    });
  }

  toggleCollectPaymentDrawer() {
    this.showCollectPaymentDrawer = true;
    this.collectThroughPgInput.amount = this.spaAmount || 0;
    this.collectThroughPgInput.clientFileId = this.cfID;
  }

  collectPayment() {
    Action.Payment.CollectThroughPg.execute(this.collectThroughPgInput, (output) => {
      // console.log("CollectThroughPg output", output);
      FSnackbar.success('Payment Link successfully generated');
      this.showCollectPaymentDrawer = false;
      this.collectThroughPgInput = new Data.Payment.CollectThroughPgInput();

      // small delay to avoid race condition 
      setTimeout(() => {
        this.getSPAPaymentRequestsList();
      }, 300)

    }, (error: any) => {

      console.log("error in CollectThroughPg", error);
      this.showCollectPaymentDrawer = false;
      this.collectThroughPgInput = new Data.Payment.CollectThroughPgInput();
      FSnackbar.error(error?.response?.data[0].message || "Something went wrong!");
    })
  }

  getSPAPaymentRequestsList() {
    Action.Payment.GetSpaPaymentRequests.execute1(this.cfID, (output) => {
      // console.log("output", output);
      this.paymentRequestOutputList = output;

    }, (error) => {
      console.log("error in getSPAPaymentRequestsList", error);
    })
  }


}
</script>

<style>
</style>
